export default __webpack_public_path__ + "static/media/laptop.ffe81476.png";